module.exports = __webpack_public_path__ + "files/bbd2e265bbc99ddc9eaf68d4d431df13.png";